import React from 'react';

const PosProductCard = ({
  productName = 'Producto',
  subtitle = '',
  imageSrc = '',
  badge = '',
  disabled = false,
  disabledReason = '',
  onClick,
  title = '',
  variant = 'default',
  selected,
  ariaLabel,
  className = '',
  children,
}) => {
  const isCompact = variant === 'compact';
  const label = [productName, subtitle].filter(Boolean).join(' - ');
  const cardAspectClassName = selected !== undefined ? 'aspect-[3/5]' : isCompact ? 'aspect-square' : 'aspect-[3/4]';
  const cardSizeClassName = isCompact
    ? 'min-h-[86px] sm:min-h-[94px] lg:min-h-[90px]'
    : 'min-h-[116px] sm:min-h-[150px] lg:min-h-[138px] xl:min-h-[150px]';
  const imageFrameClassName = isCompact
    ? 'h-8 w-8 rounded-lg sm:h-9 sm:w-9 sm:rounded-xl'
    : 'aspect-square w-[90%] rounded-lg sm:rounded-xl';
  const expandedImageClassName = isCompact
    ? 'group-hover:h-10 group-hover:w-10 sm:group-hover:h-11 sm:group-hover:w-11 lg:group-hover:h-12 lg:group-hover:w-12'
    : '';
  const expandedSurfaceClassName = isCompact
    ? 'group-hover:left-1/2 group-hover:top-1/2 group-hover:h-[128px] group-hover:w-[128px] group-hover:-translate-x-1/2 group-hover:-translate-y-1/2 sm:group-hover:h-[148px] sm:group-hover:w-[148px] lg:group-hover:h-[168px] lg:group-hover:w-[168px]'
    : 'group-hover:left-1/2 group-hover:top-1/2 group-hover:h-[144px] group-hover:w-[144px] group-hover:-translate-x-1/2 group-hover:-translate-y-1/2 sm:group-hover:h-[176px] sm:group-hover:w-[176px] lg:group-hover:h-[200px] lg:group-hover:w-[200px]';

  return (
    <button
      type="button"
      onClick={() => !disabled && onClick?.()}
      disabled={disabled}
      title={disabledReason || title || label}
      aria-label={ariaLabel || label}
      aria-pressed={selected}
      className={`group relative ${cardAspectClassName} w-full overflow-visible rounded-2xl text-center transition duration-150 ${cardSizeClassName} ${
        disabled
          ? 'cursor-not-allowed opacity-80 grayscale'
          : 'hover:z-30'
      } ${selected ? 'ring-2 ring-emerald-600 ring-offset-2' : ''} ${className}`.trim()}
    >
      <span
        className={`absolute left-0 top-0 flex h-full w-full flex-col items-center justify-start overflow-hidden rounded-xl border bg-white px-1 pb-1 pt-1.5 shadow-sm transition-all duration-150 sm:rounded-2xl sm:px-1.5 sm:pb-1 sm:pt-2 ${
          disabled
            ? 'border-gray-200'
            : `border-gray-200 group-hover:z-20 group-hover:overflow-y-auto group-hover:border-blue-200 group-hover:shadow-xl ${selected === undefined ? expandedSurfaceClassName : ''}`
        }`}
      >
        {badge && (
          <span className={`absolute left-1.5 top-1.5 z-10 rounded-full ${selected ? 'bg-emerald-700' : 'bg-red-600'} px-1.5 py-0.5 text-[10px] font-semibold uppercase text-white`}>
            {badge}
          </span>
        )}

        <span className={`${imageFrameClassName} ${expandedImageClassName} block overflow-hidden bg-gray-100 shadow-sm transition-all duration-150`}>
          {imageSrc ? (
            <img
              src={imageSrc}
              alt={productName}
              loading="lazy"
              decoding="async"
              fetchpriority="low"
              className="h-full w-full object-cover"
            />
          ) : (
            <span className="flex h-full w-full items-center justify-center text-gray-400">
              {productName?.charAt(0)?.toUpperCase() || '?'}
            </span>
          )}
        </span>

        <span
          className={`mt-0.5 min-h-[1.65rem] w-full overflow-hidden break-words px-0.5 font-semibold leading-tight text-gray-900 line-clamp-2 transition-all group-hover:line-clamp-none sm:mt-1 sm:min-h-[1.8rem] ${
            isCompact ? 'text-xs' : 'text-xs sm:text-sm'
          }`}
        >
          {productName}
        </span>

        {subtitle && (
          <span className="mt-0.5 w-full overflow-hidden break-words px-1 text-[11px] leading-snug text-gray-500 line-clamp-1 transition-all group-hover:line-clamp-none">
            {subtitle}
          </span>
        )}

        {children && (
          <span className="mt-1 w-full">
            {children}
          </span>
        )}
      </span>
    </button>
  );
};

export default PosProductCard;
